// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__1Qsoy","cancleBtn":"style_cancleBtn__3zPEN","Content":"style_Content__13coQ"};